// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"635":"6a6b95e7","648":"8eb18c13","736":"287133a0","885":"8eb18c13","893":"8eb18c13"}[chunkId] + ".chunk.css";
};